import React, { useState, useRef, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Courses from './components/Courses';
import ProjectModal from './components/ProjectModal';

// ===== PORTFOLIO DATA =====
const projects = [
  {
    id: 0,
    title: "Pragma Engine - En Progreso",
    description: "Motor de videojuegos en desarrollo con enfoque en renderizado y herramientas del editor.",
    image: process.env.PUBLIC_URL + "/assets/pragmaEngine.png",
    technologies: ["Avalonia", ".NET 8 - C#", "C++", "Veldrid", "Directx12", "Vulkan", "Python", "Antigravity", "IA", "DeepSeek"],
    role: "Desarrollador | Diseñador",
    fullDescription: "Pragma Engine es un motor de videojuegos diseñado para ofrecer un entorno de desarrollo moderno, rápido y flexible. Combina Avalonia para la interfaz del editor con Veldrid como backend gráfico, permitiendo soporte para DirectX 12, Vulkan y OpenGL. Incluye sistemas personalizados para animaciones, física, scripting y una arquitectura modular orientada a herramientas de creación de contenido. El objetivo del proyecto es construir un editor robusto y una base técnica capaz de escalar desde prototipos hasta proyectos complejos en 3D, manteniendo un flujo de trabajo eficiente y extensible.",
    platform: "Plataforma: Avalonia - Veldrid"
  },
  {
    id: 1,
    title: "Pragma - En Progreso",
    description: "Editor avanzado para automatizar procesos y crear videojuegos desde un entorno centralizado.",
    mediaType: "video",
    image: process.env.PUBLIC_URL + "/assets/pragmaVideo.mp4",
    technologies: ["Unity", "C#", "Firebase", "Unity Game Services", "API Rest", "IA", "DeepSeek"],
    role: "Desarrollador | Diseñador",
    fullDescription: "Pragma es un editor diseñado para simplificar y automatizar el flujo de trabajo en la creación de videojuegos. Construido sobre Unity, integra sistemas personalizados para manejo de assets, automatización de tareas, backend con Firebase y servicios de Unity, junto con módulos conectados mediante API REST e inteligencia artificial. El objetivo es ofrecer una herramienta completa para edición, organización, pruebas y despliegue, centralizando funciones clave en un solo entorno para acelerar el desarrollo.",
    platform: "Plataforma: Unity Editor"
  },
  {
    id: 2,
    title: "Nexus Lab - En Progreso",
    description: "Plataforma empresarial de capacitación interactiva.",
    image: process.env.PUBLIC_URL + "/assets/nexusLabBanner.jpeg",
    technologies: ["Unity", "C#", "Firebase", "Unity Game Services", "API Rest", "IA"],
    role: "Desarrollador | UX/UI",
    fullDescription: "Nexus Lab es una plataforma de capacitación empresarial enfocada en experiencias interactivas y contenido formativo gamificado. Construida sobre la infraestructura del ecosistema Pragma, integra módulos de aprendizaje, evaluaciones, seguimiento de progreso y herramientas de administración para empresas. El sistema utiliza Unity, Firebase y servicios en la nube para ofrecer despliegue multiplataforma, soporte en tiempo real y una experiencia fluida en WebGL, móviles y escritorio.",
    platform: "Plataforma: Webgl - Android - iOS - Windows - Mac"
  },
  {
    id: 3,
    title: "Tower of Ashen Souls - En Progreso",
    description: "Tower defense oscuro donde defendés la última torre del mundo frente a hordas de esqueletos y criaturas malditas.",
    image: "https://images.unsplash.com/photo-1538481199705-c710c4e965fc?w=600&h=400&fit=crop",
    technologies: ["Unity", "C#", "Unity Game Services", "Unity ADS"],
    role: "Desarrollador | Diseñador",
    fullDescription: "En Tower of Ashen Souls, el equilibrio entre la vida y la muerte está al borde del colapso. Las fuerzas de las cenizas (esqueletos, espectros y bestias corruptas) emergen sin descanso para reclamar la torre ancestral que contiene las almas de los caídos. Como guardián de este bastión, debés construir defensas, mejorar tus torres y dominar habilidades especiales para resistir oleada tras oleada de enemigos. Cada decisión estratégica define si la torre perdura… o si las almas que protege se desvanecen para siempre.",
    platform: "Plataforma: Android - iOS"
  },
  {
    id: 4,
    title: "Numverse 2048 - Finalizado",
    description: "Juego de rompecabezas que combina disparar cubos y fusionar números al estilo 2048.",
    mediaType: "video",
    image: process.env.PUBLIC_URL + "/assets/numverse.mp4",
    technologies: ["Unity", "C#", "Playfab", "Unity ADS", "Unity In-App Purchase"],
    role: "Desarrollador | Diseñador",
    fullDescription: "Numverse 2048 es un juego de rompecabezas que mezcla mecánicas de disparo con la clásica fusión de números. Apuntá, dispará cubos y combiná valores para alcanzar puntuaciones más altas mientras administrás el espacio y la velocidad de aparición. Un enfoque rápido, dinámico y adictivo del concepto 2048.",
    platform: "Plataforma: Android"
  },
  {
    id: 5,
    title: "Juegate la vida - Finalizado",
    description: "Proyecto enfocado en promover la salud mental mediante la prevención de la ansiedad, depresión, adicciones y el suicidio.",
    mediaType: "video",
    image: process.env.PUBLIC_URL + "/assets/juegateLaVida.mp4",
    technologies: ["Unity", "C#"],
    role: "Desarrollador | Diseño de Nivel",
    fullDescription: "Juegate la vida es un proyecto interactivo orientado a la promoción de la salud mental y la prevención de la ansiedad, depresión, adicciones y el suicidio. A través de experiencias y dinámicas educativas, busca generar conciencia y brindar herramientas para el bienestar emocional.",
    platform: "Plataforma: Webgl - Windows"
  },
  {
    id: 6,
    title: "Boxed Monster - Finalizado",
    description: "Experiencia VR diseñada para promover la salud mental mediante dinámicas de prevención y concientización.",
    mediaType: "video",
    image: process.env.PUBLIC_URL + "/assets/boxedMonster.mp4",
    technologies: ["Unity", "C#"],
    role: "Desarrollador | Diseño de Nivel",
    fullDescription: "Boxed Monster es una experiencia en realidad virtual enfocada en la concientización sobre la salud mental. A través de situaciones interactivas y simbólicas, busca abordar temas como ansiedad, depresión, adicciones y riesgo suicida, invitando al usuario a reflexionar mientras participa en un entorno inmersivo desarrollado para Cardboard.",
    platform: "Plataforma: Cardboard"
  },
  {
    id: 7,
    title: "Empty - Finalizado",
    description: "Juego de rompecabezas donde debés evitar caer al vacío mientras la dificultad y el entorno cambian con cada checkpoint.",
    mediaType: "video",
    image: process.env.PUBLIC_URL + "/assets/empty.mp4",
    technologies: ["Unity", "C#", "PlayFab"],
    role: "Desarrollador | Diseñador",
    fullDescription: "Empty es un juego de rompecabezas centrado en el control del movimiento y el manejo del espacio. El objetivo es mantener al personaje a salvo del vacío mientras atravesás plataformas que cambian su diseño, dificultad y mecánicas al llegar a cada checkpoint. Con progresión dinámica y desafíos crecientes, el juego combina precisión, tensión y estrategia en un formato rápido y accesible para dispositivos Android.",
    platform: "Plataforma: Android"
  },
  {
    id: 8,
    title: "Pirate Combat - Finalizado",
    description: "Ocho islas han emergido revelando fragmentos de un mapa celestial. Como buenos piratas, tu misión es encontrarlos y reclamar el tesoro.",
    mediaType: "video",
    image: process.env.PUBLIC_URL + "/assets/piratCombat.mp4",
    technologies: ["Unity", "C#", "MongoDB", "VR"],
    role: "Desarrollador | Diseño de Nivel",
    fullDescription: "Hace años, fragmentos del legendario mapa del tesoro celestial quedaron ocultos en ocho islas misteriosas. Ahora que han vuelto a la superficie, comienza la carrera por encontrarlos. En Pirate Combat explorás islas, resolvés desafíos y luchás por completar el mapa antes que nadie. Diseñado para Meta Quest 2, combina acción, exploración y combate en una experiencia VR totalmente inmersiva.",
    platform: "Plataforma: Meta Quest 2"
  },
  {
    id: 9,
    title: "Terrace Park - Finalizado",
    description: "Visualización interactiva de las torres de Terrace Park, incluyendo sus áreas principales y cada apartamento.",
    mediaType: "video",
    image: process.env.PUBLIC_URL + "/assets/terracePark.mp4",
    technologies: ["Unity", "C#", "Unity Game Services", "PlayFab"],
    role: "Desarrollador",
    fullDescription: "Terrace Park es una visualización interactiva que permite recorrer las torres del complejo, explorar sus áreas clave y revisar en detalle cada apartamento. Desarrollado con Unity y orientado a WebGL, ofrece una experiencia fluida para presentación de espacios, venta y documentación arquitectónica.",
    platform: "Plataforma: Webgl"
  },
  {
    id: 10,
    title: "Hacienda Kachipay - Finalizado",
    description: "Visualizador interactivo de proyectos de apartamentos con información y galerías detalladas.",
    mediaType: "video",
    image: process.env.PUBLIC_URL + "/assets/kachipay.mkv",
    technologies: ["Unity", "C#", "PlayFab"],
    role: "Desarrollador",
    fullDescription: "Hacienda Kachipay es una aplicación interactiva para explorar distintos proyectos de apartamentos. Permite revisar información detallada, planos y galerías de imágenes, ofreciendo una presentación clara y atractiva para clientes y exhibiciones. Desarrollado con Unity para WebGL y Windows, brinda una experiencia fluida y accesible para mostrar propiedades en diferentes plataformas.",
    platform: "Plataforma: Webgl - Windows"
  },
  {
    id: 11,
    title: "Jayedo 360° - Finalizado",
    description: "Recorrido 360° del apartamento Jayedo con visualización interactiva.",
    mediaType: "video",
    image: process.env.PUBLIC_URL + "/assets/Jayedo 360°.mkv",
    technologies: ["Unity", "C#", "PlayFab"],
    role: "Desarrollador",
    fullDescription: "Experiencia interactiva en vista 360° del apartamento Jayedo, diseñada para explorar cada espacio con detalle desde WebGL o Windows. Permite visualizar el entorno de manera inmersiva para presentación y promoción inmobiliaria.",
    platform: "Plataforma: Webgl - Windows"
  },
  {
    id: 12,
    title: "Rosé Apto 1 - Finalizado",
    description: "Recorrido 360° del apartamento Rosé Apto 1 para visualización interactiva.",
    mediaType: "video",
    image: process.env.PUBLIC_URL + "/assets/Rosé Apto 1 - 360°.mp4",
    technologies: ["Unity", "C#", "PlayFab"],
    role: "Desarrollador",
    fullDescription: "Representación interactiva en 360° del apartamento Rosé Apto 1. Ofrece una vista inmersiva del espacio pensada para exhibiciones y presentaciones inmobiliarias en WebGL y Windows.",
    platform: "Plataforma: Webgl - Windows"
  },
  {
    id: 13,
    title: "Rosé Apto 3 - Finalizado",
    description: "Recorrido 360° del apartamento Rosé Apto 3 con vista inmersiva.",
    mediaType: "video",
    image: process.env.PUBLIC_URL + "/assets/Rosé Apto 3 - 360°.mkv",
    technologies: ["Unity", "C#", "PlayFab"],
    role: "Desarrollador",
    fullDescription: "Visualización completa en 360° del apartamento Rosé Apto 3. Permite recorrer virtualmente sus espacios con una experiencia clara y fluida para presentaciones en WebGL y Windows.",
    platform: "Plataforma: Webgl - Windows"
  },
  {
    id: 14,
    title: "Children's Park - Finalizado",
    description: "Visualización 360° de elementos de parque con opciones de rotación, color y personalización.",
    mediaType: "video",
    image: process.env.PUBLIC_URL + "/assets/childrenPark.mp4",
    technologies: ["Unity", "C#", "PlayFab"],
    role: "Desarrollador",
    fullDescription: "Children's Park es una aplicación WebGL para explorar en 360° distintos elementos de parques. El usuario puede rotarlos, cambiar colores y personalizar detalles en tiempo real, ofreciendo una herramienta práctica para exhibición, diseño y selección de mobiliario urbano.",
    platform: "Plataforma: Webgl - Windows"
  },
  {
    id: 15,
    title: "VR Drummon - Finalizado",
    description: "Experiencia VR para entrenar posturas seguras al subir y bajar de camiones de minería.",
    image: "",
    technologies: ["Unity", "C#", "PlayFab", "VR"],
    role: "Desarrollador",
    fullDescription: "VR Drummon es una aplicación de realidad virtual diseñada para capacitar trabajadores en la correcta ergonomía al ascender y descender de camiones mineros. Mediante simulación inmersiva, guía al usuario en posturas seguras y prácticas que reducen el riesgo de desórdenes musculoesqueléticos. Desarrollada para Meta Quest 2 y Oculus Rift.",
    platform: "Plataforma: Meta Quest 2 - Oculus Rift"
  },
  {
    id: 16,
    title: "Furniture - Finalizado",
    description: "Visualización 360° de muebles con opciones de cambio de color y texturas.",
    mediaType: "video",
    image: process.env.PUBLIC_URL + "/assets/furniture.mp4",
    technologies: ["Unity", "C#", "PlayFab"],
    role: "Desarrollador",
    fullDescription: "Furniture es una aplicación WebGL para visualizar muebles en 360°, permitiendo rotar los objetos y modificar colores y texturas en tiempo real. Diseñada para mostrar productos de manera interactiva, es ideal para catálogos digitales y exhibiciones de mobiliario en WebGL y Windows.",
    platform: "Plataforma: Webgl - Windows"
  },
  {
    id: 17,
    title: "Garbage VR - Finalizado",
    description: "Experiencia VR educativa sobre separación de residuos para el municipio de Envigado.",
    mediaType: "video",
    image: process.env.PUBLIC_URL + "/assets/garbageVR.mp4",
    technologies: ["Unity", "C#", "VR"],
    role: "Desarrollador",
    fullDescription: "Proyecto de realidad virtual diseñado para enseñar y reforzar las prácticas correctas de separación de basuras en el municipio de Envigado. Mediante una experiencia interactiva y guiada, el usuario aprende a clasificar distintos tipos de residuos en un entorno inmersivo desarrollado para Meta Quest 2.",
    platform: "Plataforma: Meta Quest 2"
  }
];

const experience = [
  {
    year: "Oct 2022 - Actualidad",
    title: "TGA Company",
    company: "TGA Company",
    role: "Unity Developer",
    description: "Participé en proyectos multiplataforma, entregando productos pulidos y envolventes.",
    color: "#8B5CF6"
  },
  {
    year: "Jul 2019 - Nov 2023",
    title: "Parceros Games",
    company: "Parceros Games",
    role: "Co-Founder - Unity Developer - Project Manager",
    description: "Lideré el desarrollo de videojuegos para dispositivos móviles y PC",
    color: "#3B82F6"
  },
  {
    year: "May 2019 - Abril 2021",
    title: "Quandty S.A.S",
    company: "Quandty S.A.S",
    role: "Co-Founder - Unity Developer",
    description: "Dirigí el desarrollo de videojuegos de seguridad laboral en VR y AR.",
    color: "#22D3EE"
  },
  {
    year: "Jul 2018 - Dic 2018",
    title: "Arquitectos de Negocios",
    company: "Arquitectos de Negocios",
    role: "Analista Multimedia",
    description: "Diseñé y estructuré aplicaciones multimedia alineadas a objetivos empresariales.",
    color: "#F59E0B"
  }
];

const courses = [
  { year: "Agosto 2022", title: "Curso profesional de Git y GitHub", institution: "Platzi", color: "#3B82F6" },
  { year: "Agosto 2022", title: "Curso de testing de videojuegos", institution: "Platzi", color: "#22D3EE" },
  { year: "Octubre 2021", title: "Scrum Master", institution: "Udemy", color: "#8B5CF6" },
  { year: "Abril 2021", title: "C# Avanzado", institution: "LinkedIn", color: "#F59E0B" },
  { year: "Febrero 2021", title: "Tester de videojuegos", institution: "Fundación Carlos Slim", color: "#06B6D4" },
  { year: "Febrero 2021", title: "RPG Core Combat Creator With Unity", institution: "Udemy", color: "#EF4444" },
  { year: "Agosto 2018", title: "Desarrollo de videojuegos", institution: "Fundación Carlos Slim", color: "#10B981" },
  { year: "Noviembre 2017", title: "The Ultimate Guide To Real World App With Unity", institution: "Udemy", color: "#8B5CF6" },
  { year: "Noviembre 2017 - Marzo 2018", title: "Introducción a las Herramientas y Competencias para la Generación de Innovación", institution: "UPV", color: "#F59E0B" },
  { year: "Enero 2017 - Noviembre 2017", title: "Tecnólogo en Desarrollo de videojuegos", institution: "SENA", color: "#3B82F6" },
  { year: "Enero 2020", title: "Scrum Avanzado", institution: "LinkedIn", color: "#22D3EE" },
];

// ===== MAIN COMPONENT =====
export default function App() {
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const containerRef = useRef(null);

  // Detectar mobile
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Navegación
  const navigateTo = (page) => {
    if (page === currentPage || isTransitioning) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentPage(page);
      // Scroll to top on mobile
      if (isMobile) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      setTimeout(() => setIsTransitioning(false), 50);
    }, 400);
  };

  const nextPage = () => {
    if (currentPage < 3 && !isTransitioning) navigateTo(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 0 && !isTransitioning) navigateTo(currentPage - 1);
  };

  // Key handler
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const handleKey = (e) => {
      if (selectedProject) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        if (currentPage < 3 && !isTransitioning) navigateTo(currentPage + 1);
      }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        if (currentPage > 0 && !isTransitioning) navigateTo(currentPage - 1);
      }
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [currentPage, isTransitioning, selectedProject]);

  return (
    <div className="relative min-h-screen bg-dark-950 overflow-hidden noise">
      {/* Grid overlay */}
      <div className="grid-overlay" />

      {/* Background gradient orbs */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="orb w-[600px] h-[600px] bg-accent-blue/[0.04] top-[-20%] left-[-10%]" />
        <div className="orb w-[500px] h-[500px] bg-accent-purple/[0.03] bottom-[-10%] right-[-10%]" />
        <div className="orb w-[400px] h-[400px] bg-accent-cyan/[0.02] top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2" />
      </div>

      {/* Navbar */}
      <Navbar currentPage={currentPage} onNavigate={navigateTo} />

      {/* Main content */}
      <div ref={containerRef} className="relative z-10">
        {/* Page 0: Hero */}
        <div
          className={`transition-all duration-700 ${
            currentPage === 0
              ? 'opacity-100 translate-x-0'
              : currentPage > 0
                ? 'opacity-0 -translate-x-full absolute inset-0 pointer-events-none'
                : 'opacity-0 translate-x-full absolute inset-0 pointer-events-none'
          }`}
        >
          <Hero visible={currentPage === 0} />
        </div>

        {/* Page 1: Projects */}
        <div
          className={`transition-all duration-700 ${
            currentPage === 1
              ? 'opacity-100 translate-x-0'
              : currentPage > 1
                ? 'opacity-0 -translate-x-full absolute inset-0 pointer-events-none'
                : 'opacity-0 translate-x-full absolute inset-0 pointer-events-none'
          }`}
        >
          <Projects
            projects={projects}
            onSelect={setSelectedProject}
            visible={currentPage === 1}
            isMobile={isMobile}
          />
        </div>

        {/* Page 2: Experience */}
        <div
          className={`transition-all duration-700 ${
            currentPage === 2
              ? 'opacity-100 translate-x-0'
              : currentPage > 2
                ? 'opacity-0 -translate-x-full absolute inset-0 pointer-events-none'
                : 'opacity-0 translate-x-full absolute inset-0 pointer-events-none'
          }`}
        >
          <Experience
            experience={experience}
            visible={currentPage === 2}
            isMobile={isMobile}
          />
        </div>

        {/* Page 3: Courses */}
        <div
          className={`transition-all duration-700 ${
            currentPage === 3
              ? 'opacity-100 translate-x-0'
              : 'opacity-0 translate-x-full absolute inset-0 pointer-events-none'
          }`}
        >
          <Courses courses={courses} visible={currentPage === 3} />
        </div>
      </div>

      {/* Navigation buttons */}
      <div className="fixed bottom-6 lg:bottom-10 left-0 right-0 flex items-center justify-center gap-4 z-30 px-4">
        <button
          onClick={prevPage}
          disabled={currentPage === 0}
          className={`flex items-center gap-2 px-4 py-2.5 lg:px-5 lg:py-3 rounded-xl backdrop-blur-md border transition-all duration-300 ${
            currentPage === 0
              ? 'bg-white/[0.02] border-white/[0.04] text-gray-700 cursor-not-allowed'
              : 'glass glass-hover text-gray-300 hover:text-white hover:border-accent-blue/30'
          }`}
        >
          <ChevronLeft className="w-4 h-4" />
          <span className="text-xs font-medium hidden sm:inline">Anterior</span>
        </button>

        {/* Page indicators */}
        <div className="flex items-center gap-2.5">
          {[0, 1, 2, 3].map((i) => (
            <button
              key={i}
              onClick={() => navigateTo(i)}
              className="group relative"
            >
              <div
                className={`rounded-full transition-all duration-500 ${
                  currentPage === i
                    ? 'w-8 h-2 bg-gradient-to-r from-accent-blue to-accent-purple shadow-lg shadow-accent-blue/30'
                    : 'w-2 h-2 bg-white/10 hover:bg-white/20'
                }`}
              />
            </button>
          ))}
        </div>

        <button
          onClick={nextPage}
          disabled={currentPage === 3}
          className={`flex items-center gap-2 px-4 py-2.5 lg:px-5 lg:py-3 rounded-xl backdrop-blur-md border transition-all duration-300 ${
            currentPage === 3
              ? 'bg-white/[0.02] border-white/[0.04] text-gray-700 cursor-not-allowed'
              : 'glass glass-hover text-gray-300 hover:text-white hover:border-accent-blue/30'
          }`}
        >
          <span className="text-xs font-medium hidden sm:inline">Siguiente</span>
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>

      {/* Project Modal */}
      <ProjectModal
        project={selectedProject}
        onClose={() => setSelectedProject(null)}
      />

      {/* Estilos globales adicionales */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700;800;900&family=Inter:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');
      `}</style>
    </div>
  );
}
